<ng-container>
	<!-- begin: container -->
	<div class="container-fixed flex justify-between items-stretch lg:gap-4" id="header_container">
		<!-- For Mobile Start -->
		<div class="flex gap-1 lg:hidden items-center -ms-1">
			<div class="flex items-center">
				<button class="btn btn-icon btn-light btn-clear btn-sm" data-drawer-toggle="#sidebar">
					<i class="ki-filled ki-menu">
					</i>
				</button>
			</div>
		</div>

		<!-- For Mobile End -->
		<div class="flex items-stretch" id="megamenu_container">
			<div class="flex items-stretch" data-reparent="true" data-reparent-mode="prepend|lg:prepend"
				data-reparent-target="body|lg:#megamenu_container">
				<div class="hidden lg:flex lg:items-stretch" data-drawer="true"
					data-drawer-class="drawer drawer-start fixed z-10 top-0 bottom-0 w-full mr-5 max-w-[250px] p-5 lg:p-0 overflow-auto"
					data-drawer-enable="true|lg:false" id="megamenu_wrapper">

				</div>
			</div>
		</div>
		<div class="flex items-center gap-2 lg:gap-3.5">
			<td class="py-3 text-gray-700 text-sm font-normal">
				<select [(ngModel)]="selectedBranchId" (change)="onBranchChange()"
					class="select leading-normal select-sm w-auto" style="padding-right: 29px;">
					@for (c of listBranches; track $index) {
					<option [value]="c.branchID">
						{{c.branchName}}
					</option>
					}
				</select>
			</td>
			<!-- <button
				class="btn btn-icon btn-icon-lg size-9 rounded-full hover:bg-primary-light hover:text-primary text-gray-500"
				data-modal-toggle="#search_modal">
				<i class="ki-filled ki-magnifier">
				</i>
			</button>
			<div class="dropdown" data-dropdown="true" data-dropdown-offset="170px, 10px" data-dropdown-placement="bottom-end"
				data-dropdown-trigger="click|lg:click">
				<button
					class="dropdown-toggle btn btn-icon btn-icon-lg size-9 rounded-full hover:bg-primary-light hover:text-primary dropdown-open:bg-primary-light dropdown-open:text-primary text-gray-500">
					<i class="ki-filled ki-messages">
					</i>
				</button>
				<div class="dropdown-content light:border-gray-300 w-full max-w-[450px]">
					
					
					<div class="mb-2.5">
						<div class="flex grow gap-2 p-5 bg-gray-100 mb-2.5" id="join_request">
							<div class="relative shrink-0">
								<img alt="" class="rounded-full size-8" src="assets/media/avatars/300-14.png" />
								<span
									class="size-1.5 badge badge-circle bg-gray-400 absolute top-7 end-0.5 ring-1 ring-light transform -translate-y-1/2">
								</span>
							</div>
							
						</div>
						<div class="relative grow mx-5">
							<img alt="" class="rounded-full size-[30px] absolute left-0 top-2/4 -translate-y-2/4 ms-2.5"
								src="assets/media/app/final-icon-512.png" />
							<input class="input h-auto py-4 ps-12 bg-transparent" placeholder="Write a message..." type="text"
								value="" />
							<div class="flex items-center gap-2.5 absolute right-3 top-1/2 -translate-y-1/2">
								<button class="btn btn-sm btn-icon btn-light btn-clear">
									<i class="ki-filled ki-exit-up">
									</i>
								</button>
								<a class="btn btn-dark btn-sm" href="#">
									Send
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="dropdown" data-dropdown="true" data-dropdown-offset="10px, 10px" data-dropdown-placement="bottom-end"
				data-dropdown-trigger="click|lg:click">
				<button
					class="dropdown-toggle btn btn-icon btn-icon-lg size-9 rounded-full hover:bg-primary-light hover:text-primary dropdown-open:bg-primary-light dropdown-open:text-primary text-gray-500">
					<i class="ki-filled ki-element-11">
					</i>
				</button>
				<div class="dropdown-content light:border-gray-300 w-full max-w-[320px]">
					
				</div>
			</div> -->
			<div class="dropdown" data-dropdown="true" data-dropdown-offset="70px, 10px"
				data-dropdown-placement="bottom-end" data-dropdown-trigger="click|lg:click">
				<button
					class="dropdown-toggle btn btn-icon btn-icon-lg relative cursor-pointer size-9 rounded-full hover:bg-primary-light hover:text-primary dropdown-open:bg-primary-light dropdown-open:text-primary text-gray-500">
					<i class="ki-filled ki-notification-on">
					</i>
					<span *ngIf="notifications.length > 0"
						class="badge badge-dot badge-success size-[5px] absolute top-0.5 right-0.5 transform translate-y-1/2">
					</span>
				</button>
				<button (click)="openFaq()"
					class="btn btn-icon btn-icon-lg relative cursor-pointer size-9 rounded-full hover:bg-primary-light hover:text-primary text-gray-500"
					title="FAQs">
					<i class="ki-filled ki-question"></i>
				</button>
				<button (click)="openVideos()"
					class="btn btn-icon btn-icon-lg relative cursor-pointer size-9 rounded-full hover:bg-primary-light hover:text-primary text-gray-500"
					title="Tutorial Videos">
					<i class="ki-filled ki-youtube"></i>
				</button>
				<div class="dropdown-content light:border-gray-300 w-full max-w-[460px]">
					<div class="flex items-center justify-between gap-2.5 text-sm text-gray-900 font-semibold px-5 py-2.5"
						id="notifications_header">
						Notifications
						<button class="btn btn-sm btn-icon btn-light btn-clear shrink-0" data-dropdown-dismiss="true">
							<i class="ki-filled ki-cross">
							</i>
						</button>
					</div>
					<div class="border-b border-b-gray-200">
					</div>
					<div class="px-5 mb-2">
						<div class="flex flex-col">
							<div class="scrollable-y-auto" data-scrollable="true" data-scrollable-dependencies="#header"
								data-scrollable-max-height="auto" data-scrollable-offset="200px">
								<div class="flex flex-col gap-5 pt-3 pb-4 divider-y divider-gray-200">
									<div *ngFor="let notification of notifications; trackBy: trackByNotificationId">
										<div class="flex flex-col gap-3.5">
											<div class="flex flex-col gap-1">
												<div class="text-2sm font-medium mb-px">
													<a class="hover:text-primary-active text-gray-900 font-semibold">
														{{notification.patientName}}:
													</a>
													<span class="text-gray-700">
														{{notification.gpNotifyType}}
													</span>
												</div>
												<!-- <span class="flex items-center text-2xs font-medium text-gray-500">
													14 hours ago
													<span class="badge badge-circle bg-gray-500 size-1 mx-1.5">
													</span>
													Dev Team
												</span> -->
											</div>
											<div class="flex flex-wrap gap-2.5">
												<button class="btn btn-clear btn-light btn-sm"
													(click)="dismissNotification(notification.patientNotificationDetailID)">
													Dismiss
												</button>
												<button class="btn btn-clear btn-primary btn-sm"
													(click)="openNotification(notification.patientID, notification.gpNotifyTypeID)">
													{{"Open Profile"}}
												</button>
											</div>
										</div>
										<div class="border-b border-b-gray-200">
										</div>
									</div>
								</div>
							</div>
							<!-- <div class="border-b border-b-gray-200">
							</div>
							<div class="grid grid-cols-2 p-5 gap-2.5" id="notifications_all_footer">
								<button class="btn btn-sm btn-light justify-center">
									Archive all
								</button>
								<button class="btn btn-sm btn-light justify-center">
									Mark all as read
								</button>
							</div> -->
						</div>
					</div>

				</div>
			</div>
			<div class="menu" data-menu="true">
				<div class="menu-item" data-menu-item-offset="20px, 10px" data-menu-item-placement="bottom-end"
					data-menu-item-toggle="dropdown" data-menu-item-trigger="click|lg:click">
					<div class="menu-toggle btn btn-icon rounded-full">
						<img alt="" class="size-9 rounded-full border-2 border-success shrink-0"
							src="assets/media/app/final-icon-512.png" />
					</div>
					<div class="menu-dropdown menu-default light:border-gray-300 w-full max-w-[250px]">
						<div class="flex items-center justify-between px-5 py-1.5 gap-1.5">
							<div class="flex items-center gap-2">
								<!-- <img alt="" class="size-9 rounded-full border-2 border-success"
									src="assets/media/app/final-icon-512.png" /> -->
								<div class="flex flex-col gap-1.5">
									<span class="text-sm text-gray-800 font-semibold leading-none">
										{{fullName}}
									</span>
									<a class="text-xs text-gray-600 hover:text-primary font-medium leading-none"
										href="/">
										{{userName}}
									</a>
								</div>
							</div>
							<span class="badge badge-xs badge-primary badge-outline">
								{{userRole}}
							</span>
						</div>
						<div class="menu-separator">
						</div>
						<div class="flex flex-col">
							<div class="menu-item menu-item-dropdown" data-menu-item-offset="-20px, 0"
								data-menu-item-placement="left-start" data-menu-item-placement-rtl="right-start"
								data-menu-item-toggle="dropdown" data-menu-item-trigger="click|lg:hover">
								<div class="menu-link">
									<span class="menu-icon">
										<i class="ki-filled ki-setting-2">
										</i>
									</span>
									<span class="menu-title">
										My Account
									</span>
									<span class="menu-arrow">
										<i class="ki-filled ki-right text-3xs rtl:transform rtl:rotate-180">
										</i>
									</span>
								</div>
								<div class="menu-dropdown menu-default light:border-gray-300 w-full max-w-[220px]">

									<div class="menu-item">
										<a class="menu-link" [routerLink]="['/account/changepassword']">
											<span class="menu-icon">
												<i class="ki-filled ki-lock">
												</i>
											</span>
											<span class="menu-title">
												Change Password
											</span>
										</a>
									</div>
									<div class="menu-item">
										<a class="menu-link" [routerLink]="['/account/twoFASetup']">
											<span class="menu-icon">
												<i class="ki-filled ki-shield-tick">
												</i>
											</span>
											<span class="menu-title">
												Enable 2 Factor Authentication
											</span>
										</a>
									</div>
								</div>
							</div>
						</div>
						<div class="flex flex-col">
							<div class="menu-item px-4 py-1.5">
								<a class="btn btn-sm btn-primary justify-center" (click)="logOut()">
									Log out
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!-- end: container -->
</ng-container>